import { render, staticRenderFns } from "./ProfitSubscriptionView.vue?vue&type=template&id=b4055c94&scoped=true"
import script from "./ProfitSubscriptionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfitSubscriptionView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProfitSubscriptionView.vue?vue&type=style&index=0&id=b4055c94&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4055c94",
  null
  
)

export default component.exports